var map = {
	"./breakout-backup.png": 643,
	"./cd.png": 561,
	"./close.png": 856,
	"./computerBig.png": 888,
	"./computerSmall.png": 461,
	"./credits.png": 157,
	"./doomIcon.png": 937,
	"./forward.png": 455,
	"./henordleIcon.png": 274,
	"./maximize.png": 104,
	"./minimize.png": 253,
	"./myComputer.png": 951,
	"./pause.png": 908,
	"./play.png": 28,
	"./rewind.png": 551,
	"./scrabbleIcon.png": 980,
	"./showcaseIcon.png": 205,
	"./snake-backup.png": 779,
	"./trailIcon.png": 418,
	"./volumeOff.png": 149,
	"./volumeOn.png": 56,
	"./windowExplorerIcon.png": 569,
	"./windowGameIcon.png": 756,
	"./windowResize.png": 188,
	"./windowsStartIcon.png": 898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;